function toBool(value) {
    var temp = false;
    if (value == 'true' || value == true || value == 1)
        temp = true;
    return temp;
}

var fa2En = (str) => {
    var persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
    var arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
    if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
    }
    return str;
}

function random(min, max,callback) {  
    callback(Math.floor(
        Math.random() * (max - min) + min
      ));
    
}
module.exports = {
    toBool: toBool,
    fa2En:fa2En
}